import AdminRoleByScope from "../../models/AdminRoleByScope";

import type { OrganizationRoleWarning } from "./adminRoleSelection.types";

// Rôles d'administration : chacun inclut tous les autres rôles de sa portée.
const ADMIN_ROLE_LIST = ["editorAdmin", "projectAdmin", "fastAdmin"];
const CONTENT_MANAGER_ADMIN_CONFLICT_LIST = [
  "projectAdmin",
  "contentManager",
  "editorialManager",
];

function hasAdminRole(selectedRoles: string[]): boolean {
  return ADMIN_ROLE_LIST.some((role) => selectedRoles.includes(role));
}

export function isRoleLocked(role: string, selectedRoles: string[]): boolean {
  if (ADMIN_ROLE_LIST.includes(role)) return false;
  if (role === "contentManager") {
    return (
      selectedRoles.includes("analyst") ||
      selectedRoles.includes("projectAdmin")
    );
  }
  return hasAdminRole(selectedRoles);
}

export function isRoleImplied(role: string, selectedRoles: string[]): boolean {
  return !selectedRoles.includes(role) && isRoleLocked(role, selectedRoles);
}

export function toggleRole(
  selectedRoles: string[],
  role: string,
  checked: boolean,
): string[] {
  const nextRoleList = checked
    ? [...selectedRoles, role]
    : selectedRoles.filter((selectedRole) => selectedRole !== role);

  return [...AdminRoleByScope.rolesUpdate(selectedRoles, nextRoleList)];
}

export function getOrganizationRoleWarning(
  selectedRoles: string[],
  otherRoles: string[],
): OrganizationRoleWarning | null {
  if (selectedRoles.includes("editorAdmin") && otherRoles.length > 0) {
    return "adminWarning";
  }
  if (
    selectedRoles.includes("contentManagerAdmin") &&
    otherRoles.some((role) =>
      CONTENT_MANAGER_ADMIN_CONFLICT_LIST.includes(role),
    )
  ) {
    return "contentManagerWarning";
  }
  return null;
}
